// extracted by mini-css-extract-plugin
export var grid = "_13-0";
export var span1 = "_13-2";
export var span10 = "_13-b";
export var span10L = "_13-z";
export var span10M = "_13-n";
export var span10Xl = "_13-1b";
export var span11 = "_13-c";
export var span11L = "_13-10";
export var span11M = "_13-o";
export var span11Xl = "_13-1c";
export var span12 = "_13-d";
export var span12L = "_13-11";
export var span12M = "_13-p";
export var span12Xl = "_13-1d";
export var span1L = "_13-q";
export var span1M = "_13-e";
export var span1Xl = "_13-12";
export var span2 = "_13-3";
export var span2L = "_13-r";
export var span2M = "_13-f";
export var span2Xl = "_13-13";
export var span3 = "_13-4";
export var span3L = "_13-s";
export var span3M = "_13-g";
export var span3Xl = "_13-14";
export var span4 = "_13-5";
export var span4L = "_13-t";
export var span4M = "_13-h";
export var span4Xl = "_13-15";
export var span5 = "_13-6";
export var span5L = "_13-u";
export var span5M = "_13-i";
export var span5Xl = "_13-16";
export var span6 = "_13-7";
export var span6L = "_13-v";
export var span6M = "_13-j";
export var span6Xl = "_13-17";
export var span7 = "_13-8";
export var span7L = "_13-w";
export var span7M = "_13-k";
export var span7Xl = "_13-18";
export var span8 = "_13-9";
export var span8L = "_13-x";
export var span8M = "_13-l";
export var span8Xl = "_13-19";
export var span9 = "_13-a";
export var span9L = "_13-y";
export var span9M = "_13-m";
export var span9Xl = "_13-1a";
export var stretch = "_13-1";